export enum ContractorTab {
  Onboarding = 'onboarding',
  Addons = 'addons',
  Activities = 'activities',
  Notes = 'notes',
  Files = 'files',
}
